import { UseInfiniteQueryResult, UseSuspenseInfiniteQueryResult } from '@tanstack/react-query';
import { CSSProperties, useEffect } from 'react';
import { useIntersectionObserver } from 'usehooks-ts';
import LinearProgress from '~/components/data-display/LinearProgress/LinearProgress';

interface PageEndMarkerProps {
  height?: number;
  query: UseInfiniteQueryResult | UseSuspenseInfiniteQueryResult;
  style?: CSSProperties;
}

const PageEndMarker = ({ height = 100, query, style }: PageEndMarkerProps) => {
  const { ref, isIntersecting } = useIntersectionObserver({ rootMargin: `${height}px` });
  const isPageEndReached = isIntersecting;
  const { hasNextPage, isFetching, fetchNextPage } = query;
  useEffect(() => {
    if (!isPageEndReached || !hasNextPage) {
      return;
    }

    // we should not use isFetchingNextPage here! it creates many problems with tabs
    if (!isFetching) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage, isFetching, isPageEndReached]);

  return (
    <div ref={ref} style={style}>
      {query.hasNextPage || isFetching ? (
        <div style={{ height }}>
          <LinearProgress />
        </div>
      ) : null}
    </div>
  );
};

export default PageEndMarker;
